import React from "react";

type DeleteButtonProps = {
    onClick: () => void;
};

const DeleteButton: React.FC<DeleteButtonProps> = ({onClick}) => {
    return (
        <button
            className="flex items-center gap-2 bg-red-800 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition"
            onClick={onClick}
        >
            <svg
                className="w-5 h-5 text-white"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M3 6h18"/>
                <path d="M8 6V4h8v2"/>
                <path d="M19 6l-1 14H6L5 6"/>
                <path d="M10 11v6"/>
                <path d="M14 11v6"/>
            </svg>

            <span className="text-white">Elimina</span>
        </button>
    );
};

export default DeleteButton;